import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PortalTheme } from '@app/@shared/models/application-profile.model';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit {
  @Input() isLoading = false;
  @Input() buttonLabel = 'I ACCEPT THE TERMS AND CONDITIONS';
  @Output() accept = new EventEmitter<void>();

  @Input() public theme: PortalTheme | null = null;

  fgTermsAndConditions!: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createTermsAndConditionsForm();
    this.setCSSCustomProperties();
  }

  onAcceptClicked(): void {
    if (this.isFormValid()) {
      this.accept.emit();
    }
  }

  isFormValid(): boolean {
    return (
      this.fgTermsAndConditions.get('termsAndConditions')?.value &&
      this.fgTermsAndConditions.get('privacyPolicy')?.value &&
      this.fgTermsAndConditions.get('merchantFunded')?.value &&
      this.fgTermsAndConditions.get('monthlySubscription')?.value
    );
  }

  private createTermsAndConditionsForm(): void {
    this.fgTermsAndConditions = this.formBuilder.group({
      termsAndConditions: [false, Validators.pattern('true')],
      privacyPolicy: [false, Validators.pattern('true')],
      merchantFunded: [false, Validators.pattern('true')],
      monthlySubscription: [false, Validators.pattern('true')],
    });
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties
      document.documentElement.style.setProperty('--primary', this.theme.primary);
    }
  }
}
